module.exports = __webpack_public_path__ + "img/rc2.936ca994.png";